import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { getErrorTrackingObject } from '@rci/self-serve-fido/core/analytics';
import { AuthenticationService } from '@rci/self-serve-fido/shared/authentication/authentication.service';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { ApiEndpointConfigService } from '@rci/self-serve-shared';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as contactDetailActions from './actions';
import { ContactDetail, ContactDetailResponse } from './contact-detail.model';

@Injectable()
export class ContactDetailEffects {
  private readonly accountDetailService = inject(AccountDetailService);
  private readonly actions$ = inject(Actions);
  private readonly config = inject(ApiEndpointConfigService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly http = inject(HttpClient);

  loadContactDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contactDetailActions.ContactDetailActionTypes.LoadContactDetail),
      mergeMap(({ accountNumber, alias }) => {
        return this.getContactDetail$(accountNumber, alias).pipe(
          map(contactDetail => contactDetailActions.loadContactDetailSuccess({ contactDetail })),
          catchError(error =>
            of(contactDetailActions.loadContactDetailFailure({ accountNumber, error: getErrorTrackingObject(error) })),
          ),
        );
      }),
    );
  });

  private getContactDetail$(accountNumber: string, alias): Observable<ContactDetail> {
    const url = `${this.config.msapiBaseUrl}ssc/contact/v2/customer/account/${alias}/contactdetails`;
    return this.http
      .get<ContactDetailResponse>(url, { headers: this.authenticationService.getDomainServiceHeaders() })
      .pipe(
        map(response => {
          return {
            accountNumber,
            contactEmail: response.content.emailAddress,
            contactId: response.content.contactId,
            contactLanguage: response.content.language,
            homePhone: response.content.homePhone,
            mobilePhone: response.content.mobilePhone,
            businessPhone: response.content.businessPhone,
            extension: response.content.extension,
            firstName: response.content.firstName,
            lastName: response.content.lastName,
            contactIdAlias: response.content.contactIdAlias,
          };
        }),
      );
  }
}
